import * as React from "react";
import { useStyletron } from "baseui";
import { Row, expandBaseWebBorder } from "@gadgetinc/widgets";
import { ParagraphMedium } from "baseui/typography";
import { ActionIcon } from "@gadgetinc/widgets/src/icons/ActionIcon";

export const RoutesBanner = () => {
  const [css, theme] = useStyletron();

  return (
    <Row
      className={css({
        display: "flex",
        alignItems: "center",
        ...expandBaseWebBorder(theme.borders.border300),
        paddingTop: theme.sizing.scale300,
        paddingBottom: theme.sizing.scale600,
        paddingLeft: theme.sizing.scale600,
        paddingRight: theme.sizing.scale600,
        marginTop: theme.sizing.scale600,
        backgroundColor: `#FFFF8F`,
        borderRadius: theme.borders.radius200,
      })}
      $gap={theme.sizing.scale300}
    >
      <ActionIcon $size={25} />
      <div>
        <ParagraphMedium marginBottom="5px" marginTop="5px" marginLeft="15px">
          For most server side work, use actions and offload the boilerplate code to Gadget.
        </ParagraphMedium>
        <ParagraphMedium marginLeft="15px">
          <a href="/guides/actions">Learn more about actions here.</a>
        </ParagraphMedium>
      </div>
    </Row>
  );
};
